module.exports = __webpack_public_path__ + "static/media/verify-account.b0eacbdc.jpg";